import React, { Component } from 'react'
import { ProductList } from '../../../components'
import { CatalogStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'

 
class CatalogEvent extends Component {
  
  render () {
    const { isReady, data } = this.props
    if (data) {
      data.pages.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0)); 
    }

    return (
      <div className={`${CatalogStyle} catalog`}>
        <div className={`page-inner transition ${ isReady ? 'transition--ready' : '' }`}>
       
        {
          data && (
            <div className="catalog-list">
              <ProductList products={data.pages} />
            </div>
          )
        }
        </div>
      </div>
    )
  }
}

export default withLoader(CatalogEvent)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/CatalogEvent.js